import useBem from './bem';
import useSfc from './sfc';
import useI18n from './i18n';
export function use(name) {
  name = 'van-' + name;
  return [useSfc(name), useBem(name), useI18n(name)];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/utils/use/index.js
// module id = 13
// module chunks = 0 1 2 3 4 5 6 7